<div class="page-container">
  <section class="organiser-cta" aria-labelledby="organiser-cta-heading">
    <div class="organiser-cta-text">
      <h2 class="organiser-cta-heading" id="organiser-cta-heading">Want to host events?</h2>
      <p class="organiser-cta-sub">Bring your event to Hypenation and reach our community.</p>
    </div>
    <div class="organiser-cta-actions">
      <a
        [href]="organiserSignupUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="organiser-cta-link organiser-cta-link--primary"
      >
        <i nz-icon nzType="rocket" aria-hidden="true"></i>
        Become an Organiser
      </a>
      <a
        [href]="organiserLoginUrl"
        target="_blank"
        rel="noopener noreferrer"
        class="organiser-cta-link"
      >
        <i nz-icon nzType="login" aria-hidden="true"></i>
        Organiser Login
      </a>
    </div>
  </section>

  <div class="page-header">
    <h1>Organisers</h1>
    <p>Discover event organisers and follow your favourites</p>
  </div>

  <nz-spin [nzSpinning]="loading">
    <div *ngIf="organisers.length > 0; else noOrganisers" class="organisers-grid">
      <a
        *ngFor="let org of organisers"
        class="organiser-card"
        [routerLink]="['/organisers', org.uid]"
      >
        <!-- Favourite button -->
        <button
          type="button"
          class="fav-btn"
          [class.active]="isFavourite(org.uid)"
          [disabled]="isFavouriteLoading(org.uid)"
          (click)="toggleFavourite(org, $event)"
          [attr.aria-label]="isFavourite(org.uid) ? 'Unfollow ' + org.name : 'Follow ' + org.name"
        >
          <i nz-icon nzType="heart" nzTheme="fill" *ngIf="isFavourite(org.uid)" aria-hidden="true"></i>
          <i nz-icon nzType="heart" nzTheme="outline" *ngIf="!isFavourite(org.uid)" aria-hidden="true"></i>
        </button>

        <div class="org-avatar">{{ getInitial(org.name) }}</div>
        <h3 class="org-name">{{ org.name }}</h3>
        <p class="org-category" *ngIf="org.organiserCategory">{{ org.organiserCategory }}</p>
        <p class="org-location" *ngIf="org.city">
          <i nz-icon nzType="environment" aria-hidden="true"></i> {{ org.city }}<span *ngIf="org.country">, {{ org.country }}</span>
        </p>
        <p class="org-desc" *ngIf="org.description">{{ org.description }}</p>

        <div class="org-footer">
          <span class="view-profile">View Profile <i nz-icon nzType="right" aria-hidden="true"></i></span>
        </div>
      </a>
    </div>

    <ng-template #noOrganisers>
      <div class="empty-state">
        <div class="empty-icon"><i nz-icon nzType="team" aria-hidden="true"></i></div>
        <h3 class="empty-title">No Organisers Yet</h3>
        <p class="empty-desc">Public organisers will appear here once available.</p>
      </div>
    </ng-template>
  </nz-spin>
</div>
